module.exports = __webpack_public_path__ + "media/images/faces/face25-9123143f2ee0d90d93157e29e2adb77b.jpg";